"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

function getDeserializingStream(messageStream, deserializer) {
  var messageReader = messageStream.getReader();
  var deserializedStream = new ReadableStream({
    start: function start(controller) {
      function push() {
        var _this = this;

        messageReader.read().then(function (_a) {
          var done = _a.done,
              value = _a.value;
          return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _b, _c, e_1;

            return tslib_1.__generator(this, function (_d) {
              switch (_d.label) {
                case 0:
                  if (done) {
                    controller.close();
                    return [2
                    /*return*/
                    ];
                  }

                  _d.label = 1;

                case 1:
                  _d.trys.push([1, 3,, 4]);

                  _c = (_b = controller).enqueue;
                  return [4
                  /*yield*/
                  , deserializer(value)];

                case 2:
                  _c.apply(_b, [_d.sent()]);

                  push();
                  return [3
                  /*break*/
                  , 4];

                case 3:
                  e_1 = _d.sent();
                  controller.error(e_1);
                  return [3
                  /*break*/
                  , 4];

                case 4:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        });
      }

      push();
    }
  });
  return deserializedStream;
}

exports.getDeserializingStream = getDeserializingStream;